import { Alert } from '@shared/components';
import { statusLabel } from '../utils/agreementStatus';
import { canInvoice } from '../utils/invoicingRoute';
import type { AgreementStatus, InvoicingRoute } from '../types/agreements.types';

interface Props {
    status: AgreementStatus | string;
    invoicingRoute: InvoicingRoute | string | undefined;
}

export function InvoicingStatusWarning({ status, invoicingRoute }: Props) {
    if (canInvoice(invoicingRoute)) {
        return null;
    }

    return (
        <Alert variant="warning">
            This plan is {statusLabel(status)}. This plan can't be invoiced.
        </Alert>
    );
}
